const config = {
  gatsby: {
    pathPrefix: '/',
    siteUrl: 'https://hasura.io',
    gaTrackingId: null,
    trailingSlash: false,
  },
  header: {
    logo: 'eyeQ_Logo_Gradient.png',
    logoLink: 'https://eyeqinvest.co',
    title:
      '<h1 style="color:black!important">API</h1>',
    helpUrl: '',
    tweetText: '',
    social: `
			<li>
		    <a href="https://discord.com/invite/26Nvg6F97d" target="_blank" rel="noopener">
		      <div class="discordBtn">
		        <img src='https://graphql-engine-cdn.hasura.io/learn-hasura/assets/homepage/discord-brands-block.svg' alt={'Discord'}/>
		      </div>
		    </a>
		  </li>`,
    links: [{ text: '', link: '' }],
    search: {
      enabled: false,
      indexName: '',
      algoliaAppId: process.env.GATSBY_ALGOLIA_APP_ID,
      algoliaSearchKey: process.env.GATSBY_ALGOLIA_SEARCH_KEY,
      algoliaAdminKey: process.env.ALGOLIA_ADMIN_KEY,
    },
  },
  sidebar: {
    forcedNavOrder: [
      '/overview', // add trailing slash if enabled above
      '/auth',
      '/usage',
      '/signal'
    ],
    links: [{ text: 'eyeQ', link: 'https://eyeqinvest.co' }],
    frontLine: false,
    ignoreIndex: true,
    title:
      "Sections",
  },
  siteMetadata: {
    title: 'Gatsby Gitbook Boilerplate | eyeQ',
    description: 'Documentation built with mdx. Powering eyeQ API Documentation',
    ogImage: null,
    docsLocation: 'https://github.com/hasura/gatsby-gitbook-boilerplate/tree/master/content',
    favicon: 'https://graphql-engine-cdn.hasura.io/img/hasura_icon_black.svg',
  },
  pwa: {
    enabled: false, // disabling this will also remove the existing service worker.
    manifest: {
      name: 'Gatsby Gitbook Starter',
      short_name: 'GitbookStarter',
      start_url: '/',
      background_color: '#000001',
      theme_color: '#000001',
      display: 'standalone',
      crossOrigin: 'use-credentials',
      icons: [
        {
          src: 'src/pwa-512.png',
          sizes: `512x512`,
          type: `image/png`,
        },
      ],
    },
  },
};

module.exports = config;
